import { SUMO_REGION_US2 } from 'app/Config/ContextActions/ContextActionEditor/sumoRegion';

/**
 * Include the Sumo Logic base URL if it exists in the context action URL. If
 * the Sumo region exists, then check if the value is "us1". For this region,
 * inserting the region explicitly in the URL is not valid. Instead, the base
 * URL must default to "https://service.sumologic.com". Otherwise, insert the
 * region template.
 */
export const replaceSumoBaseUrl = (url: string) => {
  let newUrl = url;

  if (/{{sumobaseurl}}/.test(url)) {
    // Check if the base URL is already specified by the API. If the base URL is
    // not determined by the API, then a region is expected to not be
    // configured. Fallback to the default URL determined by
    // `replaceSumoRegion`.
    newUrl = url.replace('{{sumobaseurl}}', '');
  }

  return newUrl;
};

/**
 * Include the Sumo Logic region if it exists in the context action URL. If it
 * does not exist, replace the template value with the default Sumo region.
 */
export const replaceSumoRegion = (url: string, region?: string) => {
  let newUrl = url;

  if (/{{sumoregion}}/.test(url)) {
    newUrl = url.replace(
      /{{sumoregion}}/g,
      region ? encodeURIComponent(region) : SUMO_REGION_US2
    );
  }

  return newUrl;
};
